<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-area
                :title="checkHandleAlter ? 'Alterar cota' : 'Cadastrar cota'"
                type="fieldset"
            >
                <rkm-row class="flex-nowrap">

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="data.form.tipo"
                            label="Tipo"
                            show-default-option
                            text-field="descricao"
                            v-model="unidade.cotaTipoId"
                            value-field="id"
                            :validations="validations.tipo"

                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1" v-show="unidade.cotaTipoId == enums.tipoCota.QUANTIDADE">
                        <rkm-form-input
                            label="Cota"
                            v-model="unidade.cotaQuantidade"
                            :validations="unidade.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                            number
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1" v-show="unidade.cotaTipoId != enums.tipoCota.QUANTIDADE">
                        <rkm-form-input
                            label="Cota"
                            ref="cotaValor"
                            v-model="unidade.cotaValor"
                            :validations="unidade.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                            v-money="money"
                            prepend="R$"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="unidade.periodo"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            label="Observação"
                            v-model="unidade.observacao"
                            name="observacao"
                            rows="2"
                            max-rows="2"
                            :validations="validations.observacao"
                            class="mb-0"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>

                        <rkm-button
                            :label="false"
                            color="primary"
                            @click.stop="handleCota()"
                            class="mt-0 float-right"
                        >
                            {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                        </rkm-button>

                        <rkm-button
                            v-if="checkHandleAlter"
                            :label="false"
                            color="secondary"
                            @click.stop="hideAlter()"
                            class="mt-0 mr-2 float-right"
                        >
                            Voltar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <List
            v-if="!checkHandleAlter"
            :data="data"
            :cotaUnidadeSolicitante="cotaUnidadeSolicitante"
            :unidadeId="unidadeId"
            :infraestruturaId="infraestruturaId"
            @handleAlter="handleAlter"
            @copyCota="copyCota"
        />
    </div>
</template>


<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import List from './List'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

//Directives
import { VMoney } from 'v-money'

// Moment.
import moment from 'moment'

export default {
    components: { List },
    directives: { money: VMoney },
    mixins: [ repository, object, data, formats ],
    computed: {
        validations() {

            return {
                observacao: { max: 500 },
                cotaValor: { max: 13, min_value: 0.01 },
                cotaQuantidade: { min_value: 1, required: true },
                tipo: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        maxDate() {

            if (this.unidade.periodo.start) {

               return moment(this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD')).endOf("month").format('DD-MM-YYYY')
            }

            return null
        },
        minDate() {

            if (this.unidade.periodo.end) {

               return moment(this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD')).startOf("month").format('DD-MM-YYYY')
            }

            return null
        },
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.data.model.cotasUnidadeSolicitante.find(cota => cota.unidadeId == this.unidadeId
                        && cota.infraestruturaId == this.infraestruturaId)) {

                        this.getTotalUnidade()
                    }

                    this.getCotaAtribuidaExames()

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if ((this.cotasAtribuidas > 0)
                            && (this.formatSumMoney(this.unidade.cotaValor) + this.cotaUnidade)
                                < this.cotasAtribuidas) {

                                const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                                const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                                this.showValidationNotification(`A cota é menor que a cota atribuída
                                    para as unidades solicitantes em (Parametrização > Cotas
                                    > Laboratório > Exames > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                    local de atendimento <strong>${infraestrutura}</strong> no período de
                                    <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                    <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                    A cota deve ser maior ou igual a <strong> R$ ${this.formatMoney(this.cotasAtribuidas,2)}</strong>.
                                    `)

                            return false
                        }

                        let transferencia = this.formatMoney(this.unidade.transferencia)
                        transferencia = this.formatSumMoney(transferencia)

                        if (transferencia > this.formatSumMoney(this.unidade.cotaValor)) {


                            this.showValidationNotification(`O valor da cota informada está menor que o valores das cotas
                                transferidas. A cota deve ser maior ou igual a <strong> R$${this.formatMoney(this.transferencia,2)}</strong>.`)

                            return false
                        }

                    } else {

                        if ((this.cotasAtribuidas > 0)
                            && (Number(this.unidade.cotaQuantidade) + Number(this.cotaUnidade))
                                < this.cotasAtribuidas) {

                                const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                                const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                                this.showValidationNotification(`A cota é menor que a cota atribuída
                                    para as unidades solicitantes em (Parametrização > Cotas
                                    > Laboratório > Exames > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                    local de atendimento <strong>${infraestrutura}</strong> no período de
                                    <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                    <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                    A cota deve ser maior ou igual a <strong> ${this.formatMoney(this.cotasAtribuidas,0)}</strong>.
                                    `)

                            return false
                        }

                        if (this.unidade.transferencia > this.unidade.cotaQuantidade) {

                            this.showValidationNotification(`O valor da cota informada está menor que o valores das cotas
                                transferidas. A cota deve ser maior ou igual a <strong> ${this.formatMoney(this.unidade.transferencia,0)}</strong>.`)

                            return false
                        }
                    }

                    this.getCotaAtribuidaUnidadeSolicitante()

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if ((this.cotasAtribuidas > 0)
                            && (this.formatSumMoney(this.unidade.cotaValor) + this.cotaUnidade)
                                < this.cotasAtribuidas) {

                                    const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                                    this.showValidationNotification(`A cota é menor que a cota atribuída
                                        para as unidades solicitantes em (Parametrização > Cotas
                                        > Laboratório > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                        local de atendimento <strong>${infraestrutura}</strong> no período de
                                        <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                        <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                        A cota deve ser maior ou igual a <strong> R$ ${this.formatMoney(this.cotasAtribuidas,2)}</strong>.
                                        `)

                                    return false
                        }

                    } else {

                        if ((this.cotasAtribuidas > 0)
                            && (Number(this.unidade.cotaQuantidade) + Number(this.cotaUnidade))
                                < this.cotasAtribuidas) {

                                    const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                                    this.showValidationNotification(`A cota é menor que a cota atribuída
                                        para as unidades solicitantes em (Parametrização > Cotas
                                        > Laboratório > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                        local de atendimento <strong>${infraestrutura}</strong> no período de
                                        <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                        <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                        A cota deve ser maior ou igual a <strong>${this.formatMoney(this.cotasAtribuidas,0)}</strong>.
                                        `)

                            return false
                        }
                    }

                    const unidade = this.clone(this.unidade)

                    unidade.periodo.start = this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')
                    unidade.periodo.end = this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')

                    unidade.unidadeTipoId = this.enums.tipoUnidade.UNIDADE_SOLICITANTE

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {
                        unidade.cotaValor = unidade.cotaValor.replace('R$ ', '')
                        unidade.cotaTipoNome = 'Valor'
                        unidade.cota = unidade.cotaValor
                        unidade.saldo = unidade.cotaValor
                        unidade.cotaQuantidade = ''
                    } else {
                        unidade.cotaTipoNome = 'Quantidade'
                        unidade.cota = unidade.cotaQuantidade
                        unidade.saldo = unidade.cotaQuantidade
                        unidade.cotaValor = "0,00"
                    }

                    unidade.utilizada = '0'

                    if (this.hasIndex) {

                        const objIndex = this.cotaUnidadeSolicitante.findIndex((obj => obj.id == this.unidade.id));

                        this.$set(this.cotaUnidadeSolicitante, objIndex, this.clone(unidade))

                        this.checkHandleAlter = false
                        this.$emit('handleHideLaboratorio', false)
                        this.index = null
                    } else {

                        unidade.id = this.uniqueId(`unidade-${this.unidadeId}${this.infraestruturaId}${this.unidade.cotaTipoId}${
                            this.getFormatedDate(this.unidade.periodo.start, 'DDMMYYYY')}`)

                        this.cotaUnidadeSolicitante.push(unidade)
                    }

                    this.$emit('save')

                    this.resetForm()
                })
        },
        async validate() {

            if (!this.unidadeDisabled && this.data.model.cotasUnidadeSolicitante.find((unidade, i) =>
                i !== this.newIndex && unidade.unidadeId == this.unidadeId
                && unidade.infraestruturaId == this.infraestruturaId)) {

                this.showValidationNotification('Unidade e local de atendimento já parametrizados.')

                return false
            }

            if (this.unidadeId === null) {

                this.showValidationNotification('Obrigatório selecionar a unidade.')

                return false
            }

            if (this.unidade.cotaTipoId === null) {

                this.showValidationNotification('Obrigatório selecionar um tipo.')

                return false
            }

            const hasSetor = this.cotaUnidadeSolicitante
                .find((cc) =>
                    cc.id !== this.unidade.id
                        && cc.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                                this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD')
                            )
                            .isBetween(
                                cc.periodo.start.split("/").reverse().join("-"),
                                cc.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                    || cc.id !== this.unidade.id
                        && cc.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                                this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD')
                            )
                            .isBetween(
                                cc.periodo.start.split("/").reverse().join("-"),
                                cc.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                    || cc.id !== this.unidade.id
                        && cc.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                                this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD')
                            )
                            .isBefore(
                                cc.periodo.start.split("/").reverse().join("-"),
                            )
                        && moment(this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'))
                            .isAfter(
                                cc.periodo.end.split("/").reverse().join("-"),
                            )
                )

            if (hasSetor) {

              this.showValidationNotification(`Já existe um registro para esta unidade com o tipo e entre o período
                selecionado`)

               return false
            }

            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

            let utilizadas = this.utilizadas
            let cotaValor = this.unidade.cota

            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                utilizadas = this.utilizadas.replace('.','').replace(',','.')
                cotaValor = this.unidade.cotaValor.replace('.','').replace(',','.')

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos agendamentos para a unidade
                        solicitante <strong>${unidade.nomeFantasia}</strong> e o local de atendimento
                        <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>R$ ${this.utilizadas}</strong>.
                        `)

                    return false
                }
            } else {

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos agendamentos para a unidade
                        solicitante <strong>${unidade.nomeFantasia}</strong> e o local de atendimento
                        <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.utilizadas}</strong>.
                        `)

                    return false
                }
            }

            return true
        },
        handleCota() {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                inicio: this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD'),
                fim: this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'),
                solicitante_infraestrutura_id: this.infraestruturaId,
                cota_tipo_id: this.unidade.cotaTipoId,
            })
                .then(response => {

                    if (data.cotaTipoId == this.enums.tipoCota.VALOR) {
                        this.unidade.cota = this.unidade.cotaValor
                    } else {
                        this.unidade.cota = this.unidade.cotaQuantidade
                    }

                    this.getCotaUtilizada(response.data)

                    this.$refs.Form.validate(this.add)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(items) {

            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
            } else {

                this.utilizadas = items.quantidadeAgendada
            }
        },
        resetForm() {

            this.index = null
            this.unidade.id = null
            this.unidade.cotaTipoId = null
            this.unidade.unidadeTipoId = ''
            this.unidade.observacao = ''
            this.unidade.cotaQuantidade = ''
            this.unidade.periodo.start = null
            this.unidade.periodo.end = null
            this.unidade.cotaValor = null
            this.unidade.saldo = null
            this.unidade.utilizada = null
            this.unidade.transferencia = 0
            this.cotaOld = null
            this.unidade.valorUtilizado = 0
            this.unidade.quantidadeUtilizada = 0
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = 0;

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleAlter(index, item) {

            this.resetForm()

            this.index = index
            this.unidade.id = item.id
            this.unidade.cotaQuantidade = item.cotaQuantidade
            this.unidade.observacao = item.observacao
            this.unidade.cotaValor = item.cotaValor
            this.unidade.transferencia = item.transferencia
            this.unidade.valorUtilizado = item.valorUtilizado,
            this.unidade.quantidadeUtilizada = item.quantidadeUtilizada,
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            this.unidade.periodo.start = moment(
                item.periodo.start,
                'DD/MM/YYYY'
            ).toDate()

            this.unidade.periodo.end = moment(
                item.periodo.end,
                'DD/MM/YYYY'
            ).toDate()

            this.unidade.cotaTipoId = item.cotaTipoId

            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotaOld = item.cotaValor
            } else {

                this.cotaOld = item.cotaQuantidade
            }

            this.checkHandleAlter = true

            this.$emit('handleHideLaboratorio', true)
        },
        copyCota(item) {

            this.resetForm()

            this.unidade.cotaQuantidade = item.cotaQuantidade
            this.unidade.observacao = item.observacao
            this.unidade.cotaValor = item.cotaValor
            this.unidade.transferencia = item.transferencia
            this.unidade.valorUtilizado = item.valorUtilizado,
            this.unidade.quantidadeUtilizada = item.quantidadeUtilizada,
            this.unidade.cotaTipoId = item.cotaTipoId
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            this.unidade.periodo.start = moment(
                item.periodo.start,
                'DD/MM/YYYY'
            ).add(1, 'month').toDate()

            this.unidade.periodo.end = moment(
                item.periodo.end,
                'DD/MM/YYYY'
            ).add(1, 'month').toDate()

            this.showConfirmation(
                'Deseja replicar a cota para o próximo mês?',
                async () => this.handleCota(),
                async () => this.resetForm(),
            )
        },
        hideAlter() {

            this.checkHandleAlter = false

            this.$emit('handleHideLaboratorio', false)

            this.resetForm()
        },
        getTotalUnidade() {

            this.cotaUnidade = 0

            this.data.model.cotasUnidadeSolicitante.find(cota => cota.unidadeId == this.unidadeId
                && cota.infraestruturaId == this.infraestruturaId).cotaUnidadeSolicitante.filter((unidade) =>
                  unidade.cotaTipoId == this.unidade.cotaTipoId
                && this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD').substr(0, 4) ==
                    unidade.periodo.start.split("/").reverse().join("-").substr(0, 4)
                && this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD').substr(5, 2) ==
                    unidade.periodo.start.split("/").reverse().join("-").substr(5, 2)
                && this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD').substr(0, 4) ==
                    unidade.periodo.end.split("/").reverse().join("-").substr(0, 4)
                && this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD').substr(5, 2) ==
                    unidade.periodo.end.split("/").reverse().join("-").substr(5, 2)
            ).map(cotaUnidade => {

                if (this.unidade.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                    if (cotaUnidade.cota) {
                        this.cotaUnidade = this.cotaUnidade + Number(cotaUnidade.cota);
                    }

                } else {

                    if (cotaUnidade.cota) {
                        this.cotaUnidade = this.cotaUnidade + this.formatSumMoney(cotaUnidade.cota);
                    }
                }
            })

            if (this.unidade.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                if (this.hasIndex) {

                    if (this.cotaUnidade) {
                        this.cotaUnidade = this.cotaUnidade - Number(this.cotaOld);
                    }
                }

            } else {

                if (this.hasIndex) {

                    if (this.cotaUnidade) {
                        this.cotaUnidade = this.cotaUnidade - this.formatSumMoney(this.cotaOld);
                    }
                }
            }
        },
        getCota(){

            return this.data.model.cotasLaboratorio.map(item => item.cotaLaboratorio.filter(field =>
                field.cotaTipoId == this.unidade.cotaTipoId
                && moment(

                    field.periodo.start.split("/").reverse().join("-"),
                )
                .isBetween(
                    this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD'),
                    this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'),
                    null,
                    '[]'
                )
                && moment(
                    field.periodo.end.split("/").reverse().join("-"),
                )
                .isBetween(
                    this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD'),
                    this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'),
                    null,
                    '[]'
                )
            ))
        },
        getCotaAtribuidaExames() {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            let verifyItem = this.getCota()

            Object.keys(verifyItem).forEach(a => {
                Object.keys(verifyItem[a]).forEach(b => {

                    Object.keys(verifyItem[a][b].exames).forEach(c => {

                        this.cotaAtribuida = verifyItem[a][b].exames[c].unidadeSolicitante.filter(field =>
                            field.unidadeSolicitanteId === this.unidadeId
                            && field.infraestruturaSolicitanteId === this.infraestruturaId
                        )
                        .reduce((sum, element) => {

                            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                        if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                        } else {
                            this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                        }
                    })
                })
            })
        },
        getCotaAtribuidaUnidadeSolicitante() {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            let verifyItem = this.getCota()

            Object.keys(verifyItem).forEach(a => {
                Object.keys(verifyItem[a]).forEach(b => {

                    this.cotaAtribuida = verifyItem[a][b].unidadeSolicitante.filter(field =>
                        field.unidadeSolicitanteId === this.unidadeId
                        && field.infraestruturaSolicitanteId === this.infraestruturaId
                    )
                    .reduce((sum, element) => {

                        if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            if (element.cota) {

                                sum = sum + this.formatSumMoney(element.cota);
                            }
                        } else {

                            if (element.cota) {

                                sum = Number(sum) + Number(element.cota);
                            }
                        }

                        return sum
                    },0)

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    } else {
                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    }
                })
            })
        },
    },
    props: {
        data: { type: Object, required: true },
        cotaUnidadeSolicitante: { type: Array, required: true },
        unidadeId: { type: Number, default: null },
        newIndex: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        unidadeDisabled: { type: Boolean, default: false },
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {},
        unidade: {
            id: null,
            tipoUnidade: null,
            cotaTipoId: null,
            cotaTipoNome: null,
            cotaValor: '',
            cotaQuantidade: '',
            valorUtilizado: 0,
            quantidadeUtilizada: 0,
            saldo: '',
            utilizada: '',
            periodo: {
                start: null,
                end: null
            },
            observacao: null,
            transferencia: 0,
        },
        cotasAtribuidas: null,
        cotaAtribuida: null,
        cotaUnidade: 0,
        cotaOld: null,
        utilizadas: null,

        checkHandleAlter: false,
        index: null,
        enums: {
            tipoCota,
            tipoUnidade,
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
    }),
}
</script>